// City finder / autocomplete widget for homepage
(() => {
  const PAGES = JSON.parse(document.getElementById('pages-data').textContent);

  const svcSelect = document.getElementById('svc-select');
  const cityInput = document.getElementById('city-input');
  const sugBox = document.getElementById('city-suggestions');
  const finderMsg = document.getElementById('finder-msg');
  const findBtn = document.getElementById('find-btn');

  let activeIdx = -1;
  let currentMatches = [];
  let selectedCitySlug = null;

  const showMsg = (txt) => {
    finderMsg.textContent = txt;
    finderMsg.classList.remove('hidden');
  };
  const hideMsg = () => { finderMsg.classList.add('hidden'); };

  const hideSuggestions = () => {
    sugBox.classList.add('hidden');
    sugBox.innerHTML = '';
    currentMatches = [];
    activeIdx = -1;
  };

  const renderSuggestions = (matches, query) => {
    currentMatches = matches;
    activeIdx = -1;
    if (!matches.length) { hideSuggestions(); return; }
    const isZip = /^\d{3,5}$/.test(query);
    sugBox.innerHTML = matches.map((p, i) => {
      const matchedZip = isZip && p.z ? p.z.find(z => z.startsWith(query)) : null;
      const zipLabel = matchedZip ? `<span class="sug-svc">${matchedZip}</span>` : '';
      return `<div class="sug-item" data-idx="${i}"><span class="sug-city"><strong>${p.cn}</strong>, ${p.st}</span>${zipLabel}</div>`;
    }).join('');
    sugBox.classList.remove('hidden');
  };

  const pickSuggestion = (p) => {
    cityInput.value = `${p.cn}, ${p.st}`;
    selectedCitySlug = p.c;
    hideSuggestions();
    hideMsg();
  };

  const getMatchingPages = (q) => {
    const svc = svcSelect.value;
    const out = [];
    const isZip = /^\d{3,5}$/.test(q);
    for (let i = 0; i < PAGES.length; i++) {
      const p = PAGES[i];
      if (svc && !p.svcs.includes(svc)) continue;
      if (isZip) {
        // Match against zip codes
        if (p.z && p.z.some(z => z.startsWith(q))) {
          out.push(p);
          if (out.length >= 8) break;
        }
      } else if (`${p.cn}, ${p.st}`.toLowerCase().includes(q)) {
        out.push(p);
        if (out.length >= 8) break;
      }
    }
    return out;
  };

  cityInput.addEventListener('input', function () {
    selectedCitySlug = null;
    const q = this.value.trim().toLowerCase();
    if (q.length < 2) { hideSuggestions(); return; }
    renderSuggestions(getMatchingPages(q), q);
  });

  cityInput.addEventListener('keydown', (e) => {
    if (!currentMatches.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = Math.min(activeIdx + 1, currentMatches.length - 1);
      updateActiveClass();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = Math.max(activeIdx - 1, -1);
      updateActiveClass();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIdx >= 0) pickSuggestion(currentMatches[activeIdx]);
      else if (currentMatches.length === 1) pickSuggestion(currentMatches[0]);
    } else if (e.key === 'Escape') {
      hideSuggestions();
    }
  });

  const updateActiveClass = () => {
    sugBox.querySelectorAll('.sug-item').forEach((el, i) => {
      el.classList.toggle('active', i === activeIdx);
    });
  };

  sugBox.addEventListener('mousedown', (e) => {
    const item = e.target.closest('.sug-item');
    if (!item) return;
    e.preventDefault();
    pickSuggestion(currentMatches[+item.dataset.idx]);
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('#city-wrap')) hideSuggestions();
  });

  svcSelect.addEventListener('change', () => {
    selectedCitySlug = null;
    const q = cityInput.value.trim().toLowerCase();
    if (q.length >= 2) renderSuggestions(getMatchingPages(q));
  });

  const goToListing = () => {
    hideMsg();
    const svc = svcSelect.value;
    if (!svc) { showMsg('Please select a service first.'); svcSelect.focus(); return; }

    let citySlug = selectedCitySlug;

    if (!citySlug) {
      const q = cityInput.value.trim().toLowerCase();
      if (!q) { showMsg('Please enter your city.'); cityInput.focus(); return; }
      const matches = getMatchingPages(q);
      if (matches.length === 1) {
        citySlug = matches[0].c;
      } else if (matches.length > 1) {
        renderSuggestions(matches, q);
        showMsg('Select a city from the list.');
        cityInput.focus();
        return;
      } else {
        // City not found for this service — try finding the city without service filter
        // and suggest the nearest city that has this service
        const cityOnly = [];
        for (const p of PAGES) {
          if (`${p.cn}, ${p.st}`.toLowerCase().includes(q)) cityOnly.push(p);
        }
        if (cityOnly.length > 0) {
          // City exists but doesn't have this service — find nearest city with the service
          const target = cityOnly[0];
          let nearest = null;
          let nearestName = '';
          for (const p of PAGES) {
            if (p.svcs.includes(svc) && p.c !== target.c) {
              // Simple string proximity — cities in same state first
              if (!nearest || (p.st === target.st && nearest.st !== target.st)) {
                nearest = p;
                nearestName = `${p.cn}, ${p.st}`;
              }
            }
          }
          if (nearest) {
            citySlug = nearest.c;
            cityInput.value = nearestName;
            selectedCitySlug = citySlug;
            showMsg(`Showing results for ${nearestName} (nearest to ${target.cn}).`);
          } else {
            showMsg("We don\u2019t have that service in your area yet.");
            cityInput.focus();
            return;
          }
        } else {
          showMsg("We don\u2019t have that city yet\u2014try another nearby city.");
          cityInput.focus();
          return;
        }
      }
    }

    window.location.href = `/best-${svc}-${citySlug}/`;
  };

  findBtn.addEventListener('click', goToListing);
  cityInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !currentMatches.length) goToListing();
  });
})();
